import script from "./newsAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./newsAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./newsAdminPage.vue?vue&type=style&index=0&id=ecb10b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecb10b60"]])

export default __exports__